// extracted by mini-css-extract-plugin
export default {"dropdown":"share-box_dropdown__z6giS","icon":"share-box_icon__KkXgd","option":"share-box_option__E8soC","optionIcon":"share-box_optionIcon__Q2oFg"};